import { integerFormat } from 'common/helpers/numberHelper';

const Discount = (props) => {
  const { product } = props;
  if (!product.variants) {
    return null;
  }
  const variant = product.variants[0];
  if (!variant) {
    return null;
  }
  if (!variant.addToCartPrice) {
    return null;
  }
  const comparePrice = variant.comparePrice || variant.price;
  if (variant.addToCartPrice >= comparePrice) {
    return null;
  }
  const discount = (comparePrice - variant.addToCartPrice) / comparePrice;
  return (
    <div className="c7-product__variant__price__sale">
      {integerFormat(discount * 100)}% off
    </div>
  );
};

export default Discount;
